// extracted by mini-css-extract-plugin
module.exports = {"imgActiva":"Opiniones_imgActiva__3QWA2","imagenes":"Opiniones_imagenes__1k9vQ","opinion":"Opiniones_opinion__1kmsq","nombre":"Opiniones_nombre__1_G6I"};